<template>
  <header class="cfg-topbar">
    <div class="cfg-topbar__left">
      <span class="cfg-topbar__section">Configuración</span>
      <span class="cfg-topbar__park-name">{{ park?.name }}</span>
    </div>

    <div class="cfg-topbar__divider"></div>

    <Transition name="cfg-fade" mode="out-in">
      <span :key="activeLabel" class="cfg-topbar__breadcrumb">{{ activeLabel }}</span>
    </Transition>

    <div v-if="pendingSubsections.length" class="cfg-topbar__pending-wrap" @mouseenter="tooltipOpen = true" @mouseleave="tooltipOpen = false">
      <span class="cfg-topbar__pending-tag">
        <span class="cfg-topbar__pending-dot"></span>
        {{ pendingSubsections.length === 1 ? 'Cambios sin guardar' : `${pendingSubsections.length} subsecciones sin guardar` }}
      </span>
      <div v-if="tooltipOpen && pendingSubsections.length > 1" class="cfg-topbar__tooltip">
        {{ pendingSubsections.join(' · ') }}
      </div>
    </div>

    <div class="cfg-topbar__spacer"></div>

    <div class="cfg-topbar__user-avatar">{{ userInitials }}</div>
  </header>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  park: { type: Object, default: null },
  activeLabel: { type: String, default: '' },
  pendingSubsections: { type: Array, default: () => [] },
  userName: { type: String, default: 'Usuario' },
})

const tooltipOpen = ref(false)

const userInitials = computed(() => props.userName.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase())
</script>

<style scoped>
.cfg-topbar {
  display: flex;
  align-items: center;
  padding: 0.6rem 1.5rem;
  background: var(--side-panel);
  border-left: 1px solid var(--border-subtle);
  gap: 0.75rem;
  height: 56px;
  box-sizing: border-box;
}

.cfg-topbar__left { display: flex; flex-direction: column; flex-shrink: 0; }
.cfg-topbar__section { font-family: var(--font-display); font-weight: 700; font-size: 15px; color: #ffffff; }
.cfg-topbar__park-name { font-family: var(--font-body); font-size: 11px; color: rgba(255, 255, 255, 0.6); }

.cfg-topbar__divider { width: 1px; align-self: stretch; background: rgba(255, 255, 255, 0.15); flex-shrink: 0; }
.cfg-topbar__spacer { flex: 1; }

.cfg-topbar__breadcrumb { font-family: var(--font-body); font-size: 13px; color: rgba(255, 255, 255, 0.7); }

.cfg-fade-enter-active, .cfg-fade-leave-active { transition: opacity 150ms ease; }
.cfg-fade-enter-from, .cfg-fade-leave-to { opacity: 0; }

.cfg-topbar__pending-wrap { position: relative; margin-left: 12px; }

.cfg-topbar__pending-tag {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  height: 22px;
  background: #92400e;
  color: #fde68a;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 500;
  border-radius: 20px;
  padding: 0 0.65rem;
  white-space: nowrap;
}

.cfg-topbar__pending-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fde68a;
  animation: cfg-blink 1.4s ease-in-out infinite;
}

@keyframes cfg-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.cfg-topbar__tooltip {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  background: #1e3a5f;
  color: #ffffff;
  font-family: var(--font-body);
  font-size: 11px;
  padding: 0.4rem 0.6rem;
  border-radius: 8px;
  white-space: nowrap;
  z-index: 200;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.cfg-topbar__user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
</style>